import React from 'react';
import {
  Box,
  Grid,
  Container,
  SpaceBetween,
  Spinner,
  TextContent
} from '@cloudscape-design/components';

const LoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <Box
      padding={{ top: 'l' }}
      textAlign="center"
    >
      <Grid
        gridDefinition={[{ colspan: 3 }, { colspan: 6 }, { colspan: 3 }]}
      >
        <div></div>
        <Container>
          <SpaceBetween size="l" direction="vertical" alignItems="center">
            <Spinner size="large" />
            <TextContent>
              <h2>{message}</h2>
              <p>Please wait while we load your content</p>
            </TextContent>
          </SpaceBetween>
        </Container>
        <div></div>
      </Grid>
    </Box>
  );
};

export default LoadingScreen;
